import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";

var HeaderMessages =
/*#__PURE__*/
function () {
  function HeaderMessages() {
    _classCallCheck(this, HeaderMessages);
  }

  _createClass(HeaderMessages, null, [{
    key: "CreateNewHeaderMessage",
    value: function CreateNewHeaderMessage(message, fromDate, toDate, userId) {
      return new Promise(function (resolve, reject) {
        axios.post("/HeaderMessage/CreateNewHeaderMessage", {
          Message: message,
          From: fromDate,
          To: toDate,
          UserId: userId
        }).then(function (response) {
          resolve(response);
        }).catch(function (ex) {
          console.log(ex);
          reject(ex);
        });
      });
    }
  }, {
    key: "GetCurrentHeaderMessages",
    value: function GetCurrentHeaderMessages() {
      return new Promise(function (resolve, reject) {
        axios.get("/HeaderMessage/GetCurrentHeaderMessages").then(function (response) {
          resolve(response);
        }).catch(function (ex) {
          console.log(ex);
          reject(ex);
        });
      });
    }
  }, {
    key: "GetAllHeaderMessages",
    value: function GetAllHeaderMessages() {
      return new Promise(function (resolve, reject) {
        axios.get("/HeaderMessage/GetAllCurrentAndFutureHeaderMessages").then(function (response) {
          resolve(response);
        }).catch(function (ex) {
          console.log(ex);
          reject(ex);
        });
      });
    }
  }, {
    key: "DeleteMessage",
    value: function DeleteMessage(messageId) {
      return new Promise(function (resolve, reject) {
        axios.delete("/HeaderMessage/DeleteHeaderMessage", {
          params: {
            messageId: messageId
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (ex) {
          console.log(ex);
          reject(ex);
        });
      });
    }
  }, {
    key: "CloneMessage",
    value: function CloneMessage(messageId, userId) {
      return new Promise(function (resolve, reject) {
        axios.get("/HeaderMessage/CloneHeaderMessage", {
          params: {
            messageNumber: messageId,
            userNumber: userId
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (ex) {
          console.log(ex);
          reject(ex);
        });
      });
    }
  }, {
    key: "GetHeaderMessage",
    value: function GetHeaderMessage(messageId) {
      return new Promise(function (resolve, reject) {
        axios.get("/HeaderMessage/GetHeaderMessage", {
          params: {
            messageId: messageId
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (ex) {
          console.log(ex);
          reject(ex);
        });
      });
    }
  }, {
    key: "UpdateHeaderMessage",
    value: function UpdateHeaderMessage(message, fromDate, toDate, userId, messageId) {
      return new Promise(function (resolve, reject) {
        axios.post("/HeaderMessage/UpdateHeaderMessage", {
          Message: message,
          From: fromDate,
          To: toDate,
          UserId: userId,
          MessageId: messageId
        }).then(function (response) {
          resolve(response);
        }).catch(function (ex) {
          console.log(ex);
          reject(ex);
        });
      });
    }
  }]);

  return HeaderMessages;
}();

export { HeaderMessages as default };